// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__sjEYb","success":"Alert_success__zgGYN","error":"Alert_error__tH-nl","closebtn":"Alert_closebtn__2cLme","hide":"Alert_hide__jqhWn"};